import { RESOURCE_TYPE } from "src/constant";

export default (ubaData: HBEventData): RESOURCE_TYPE => {
    // if(/javascript/.test(ubaData.restype)) {
    //     return RESOURCE_TYPE.SCRIPT;
    // }

    return ubaData.rtype as RESOURCE_TYPE;
}
